(function () {
  if (window.__mtScriptsInit) return;
  window.__mtScriptsInit = true;

  function mtInitReveals() {
    var items = document.querySelectorAll('.mt-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach(function (el) { obs.observe(el); });
  }

  function mtInitContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length) return;
    var animated = new WeakSet();
    function anim(el) {
      if (animated.has(el)) return;
      animated.add(el);
      var target = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      var suffix = el.getAttribute('data-mt-sufijo') || '';
      var decimals = (el.getAttribute('data-mt-contador').split('.')[1] || '').length;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toFixed(decimals) + suffix;
      }
      requestAnimationFrame(step);
      setTimeout(function () {
        el.textContent = target.toFixed(decimals) + suffix;
      }, duration + 400);
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(anim);
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            anim(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function mtInitGaleriaProducto() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal] img');
      var minis = galeria.querySelectorAll('[data-mt-miniatura]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-mt-full');
          var alt = mini.getAttribute('data-mt-alt') || '';
          if (!src) return;
          principal.setAttribute('src', src);
          principal.setAttribute('alt', alt);
          minis.forEach(function (m) { m.classList.remove('is-activa'); });
          mini.classList.add('is-activa');
        });
      });
    });
  }

  function mtInitCantidad() {
    document.querySelectorAll('[data-mt-cantidad]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var menos = wrap.querySelector('[data-mt-menos]');
      var mas = wrap.querySelector('[data-mt-mas]');
      if (!input) return;
      function clamp(v) { return Math.max(1, Math.min(99, v)); }
      if (menos) menos.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change'));
      });
      if (mas) mas.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) + 1);
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  function mtInitVariantes() {
    document.querySelectorAll('[data-mt-producto-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector('input[name="id"]');
      var precioActual = form.querySelector('[data-mt-precio-actual]');
      var precioAntes = form.querySelector('[data-mt-precio-antes]');
      var botonComprar = form.querySelector('[data-mt-boton-comprar]');
      var botonPagar = form.querySelector('[data-mt-boton-pagar]');
      var disponibilidad = form.querySelector('[data-mt-disponibilidad]');
      var opciones = form.querySelectorAll('[data-mt-opcion]');

      function moneda(cents) {
        if (window.Shopify && window.Shopify.formatMoney && window.theme_money_format) {
          return window.Shopify.formatMoney(cents, window.theme_money_format);
        }
        return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
      }

      function seleccionActual() {
        var vals = [];
        opciones.forEach(function (grupo) {
          var activo = grupo.querySelector('.is-activa');
          if (activo) vals.push(activo.getAttribute('data-mt-valor'));
        });
        return vals;
      }

      function encontrarVariante() {
        var vals = seleccionActual();
        return variantes.find(function (v) {
          return v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
        });
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;
        idInput.value = variante.id;
        if (precioActual) precioActual.textContent = moneda(variante.price);
        if (precioAntes) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioAntes.textContent = moneda(variante.compare_at_price);
            precioAntes.style.display = '';
          } else {
            precioAntes.style.display = 'none';
          }
        }
        var disponible = variante.available;
        [botonComprar, botonPagar].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = !disponible;
        });
        if (disponibilidad) disponibilidad.textContent = disponible ? '' : 'Agotado temporalmente';
      }

      opciones.forEach(function (grupo) {
        grupo.querySelectorAll('[data-mt-valor]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            grupo.querySelectorAll('[data-mt-valor]').forEach(function (b) { b.classList.remove('is-activa'); });
            btn.classList.add('is-activa');
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  function mtInitCompraDirecta() {
    document.querySelectorAll('[data-mt-producto-form], [data-mt-comprar-directo]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        var esComprarAhora = submitter && (submitter.name === 'checkout' || submitter.hasAttribute('data-mt-boton-pagar'));
        if (!esComprarAhora) return; // deja que "Añadir al carrito" siga su envío normal
        e.preventDefault();
        var textoOriginal = submitter.textContent;
        submitter.disabled = true;
        submitter.textContent = 'Procesando…';
        var formData = new FormData(form);
        formData.delete('checkout');
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        })
          .then(function (res) { if (!res.ok) throw new Error('add-failed'); return res.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            submitter.disabled = false;
            submitter.textContent = textoOriginal;
            window.location.href = '/cart';
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    mtInitReveals();
    mtInitContadores();
    mtInitGaleriaProducto();
    mtInitCantidad();
    mtInitVariantes();
    mtInitCompraDirecta();
  });
})();
